export function ADDRESS(addressId) {
  return '/access/address/' + addressId + '/';
}
export function ACCESSCODE(gatewayId) {
  return '/access/lock_access_code/' + gatewayId + '/';
}
